export const GET_USER_REQUEST = "get/user/request";
export const GET_USER_SUCCESS = "get/user/success";
export const GET_USER_FAILURE = "get/user/failure";

export const DELETE_USER_REQUEST = "delete/user/request";
export const DELETE_USER_SUCCESS = "delete/user/success";
export const DELETE_USER_FAILURE = "delete/user/failure";

export const ADMIN_POST_REQUEST = "admin/post/request";
export const ADMIN_POST_SUCCESS = "admin/post/success";
export const ADMIN_POST_FAILURE = "admin/post/failure";

export const ADMIN_DELETE_POST_REQUEST = "admin/deletepost/request";
export const ADMIN_DELETE_POST_SUCCESS = "admin/deletepost/success";
export const ADMIN_DELETE_POST_FAILURE = "admin/deletepost/failure";
